// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"708":"a59b0984","787":"bd5240c2"}[chunkId] + ".chunk.js";
};